var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var pageModel = Backbone.Model.extend({
  initialize: function (options) {

  	// remove buttons which are not alowed for the current user
  	if (_.has(options, 'buttons')) {

  		var buttons = _.pickBy(options.buttons, function (o) {
  		  return App.session.user.hasRole(o.roles)
  		})
  		this.set('buttons', buttons)
  	}

  	// remove tabs which are not alowed for the current user
  	if (_.has(options, 'tabs')) {

  		var tabs = _.pickBy(options.tabs, function (o) {
  		  return App.session.user.hasRole(o.roles)
  		})
  		this.set('tabs', tabs)
  	}
  }
  // 
  // 

})

module.exports = pageModel



// WEBPACK FOOTER //
// ./js/common/page-model.js